import { Button, Form, Input, Modal } from "antd";
import React, { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { authAPI, companyAPI } from "../../api/api";
import useOnlyLatinLetterInputHandlerAndModal from "../../hooks/useOnlyLatinLetterInputHandlerAndModal";
import styles from "./CompleteCompanyNameModal.module.less";
export const CompleteCompanyNameModal = () => {
  const { user } = useSelector((state) => state.auth);
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation([
    "ConfirmPageChangeModal",
    "CompleteCompanyNameModal",
    "FS10-AddNewProduct",
    "FS8-changeCompanyProfile",
    "FA40-SendEmailToUser",
    "AdminLogin"
  ]);
  const { OnlyLatinLettersTextInput, OnlyLatinLettersModal } =
    useOnlyLatinLetterInputHandlerAndModal();
  const [form] = Form.useForm();

  const LATIN_NAME_REGEX = /^[\p{Script=Latin}\s'-]+$/u;

  const isLatinName = (value) => {
    if (!value) return false;
    return LATIN_NAME_REGEX.test(value.trim());
  };
  const needNameFields = useMemo(() => {
    if (!user) return false;

    return !isLatinName(user?.firstName) || !isLatinName(user?.lastName);
  }, [user]);

  const handleModalSubmit = async () => {
    const data = form.getFieldsValue();

    const payload = needNameFields
      ? {
          companyName: data.companyName,
          firstName: data.firstName,
          lastName: data.lastName
        }
      : data.companyName;

    await companyAPI
      .updateCompanyNameOauth(payload)
      .then(async () => {
        setModalOpen(false);
        await authAPI.whoAmI();
      })
      .catch(() =>
        form.setFields([
          {
            name: "companyName",
            errors: [t("modalMessages.error", { ns: "AdminLogin" })]
          }
        ])
      );
  };

  useEffect(() => {
    if (user?.company?.companyName === "n/a") {
      setModalOpen(true);
    }
  }, [user, user?.company?.companyName]);

  return (
    <>
      {OnlyLatinLettersModal}
      <Modal
        width={520}
        visible={modalOpen}
        onOk={handleModalSubmit}
        footer={[
          <Button
            key={0}
            className={`btn btn_v2`}
            size="large"
            onClick={() => {
              form.getFieldsError();
              form.validateFields().then(() => {
                handleModalSubmit();
              });
            }}
          >
            {t("Buttons.Submit", { ns: "FA40-SendEmailToUser" })}
          </Button>
        ]}
        closable={false}
      >
        <Form
          style={{ width: "100%" }}
          colon={false}
          name="changeProfile"
          autoComplete="off"
          requiredMark={false}
          validateTrigger="onSubmit"
          form={form}
        >
          {/* <p>{t("title", { ns: "CompleteCompanyNameModal" })}</p> */}
          {needNameFields && (
            <>
              <Form.Item
                className={styles.input}
                name="firstName"
                label={t("firstname", { ns: "CompleteCompanyNameModal" })}
                rules={[
                  {
                    required: true,
                    message: t("required", { ns: "AdminLogin" })
                  }
                ]}
              >
                <Input
                  onChange={(e) => {
                    OnlyLatinLettersTextInput(
                      e.target.value,
                      "firstName",
                      form,
                      true,
                      null,
                      null,
                      true
                    );
                  }}
                  size="large"
                />
              </Form.Item>

              <Form.Item
                className={styles.input}
                name="lastName"
                label={t("lastname", { ns: "CompleteCompanyNameModal" })}
                rules={[
                  {
                    required: true,
                    message: t("required", { ns: "AdminLogin" })
                  }
                ]}
              >
                <Input
                  onChange={(e) => {
                    OnlyLatinLettersTextInput(
                      e.target.value,
                      "lastName",
                      form,
                      true,
                      null,
                      null,
                      true
                    );
                  }}
                  size="large"
                />
              </Form.Item>
            </>
          )}
          <Form.Item
            className={styles.input}
            name="companyName"
            label={t("companyname", { ns: "CompleteCompanyNameModal" })}
            rules={[
              {
                required: true,
                message: t("companyNameError", { ns: "FS8-changeCompanyProfile" })
              }
            ]}
          >
            <Input
              onChange={(e) => {
                OnlyLatinLettersTextInput(
                  e.target.value,
                  "companyName",
                  form,
                  true,
                  null,
                  null,
                  true
                );
              }}
              size="large"
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
